export const railSkeletonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '0 18px 14px',
};

export const stepSkeletonGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '6px',
  flex: 1,
  minWidth: 0,
};

export const progressBarSkeletonStyles = {
  borderRadius: '999px',
};
